import type { RootState } from "@/app/store/type";
import { createSelector } from "@reduxjs/toolkit";
import type { DistrictType } from "./types";

export const selectFetchSiteDataIsError = (state: RootState) =>
    state.siteData.error != null;
export const selectFetchSiteDataIsLoading = (state: RootState) =>
    state.siteData.isLoading;

export const selectContacts = (state: RootState) =>
    state.siteData.data?.contacts;

export const selectExclusiveSelectionLink = (state: RootState) =>
    state.siteData.data?.exclusiveSelectionLink;

export const selectDistricts = (state: RootState) =>
    state.siteData.data?.districts;

export const makeSelectDistrictById = (id: number) =>
    createSelector(selectDistricts, (districts) =>
        districts?.find((d: DistrictType) => d.id === id)
    );

export const selectPrices = (state: RootState) => state.siteData.data?.prices;

export const selectRoomOptions = (state: RootState) =>
    state.siteData.data?.roomOptions;

export const selectStatusList = (state: RootState) =>
    state.siteData.data?.statusList;

export const selectTiers = (state: RootState) => state.siteData.data?.tiers;
